module.exports = __webpack_public_path__ + "static/media/log_1.3b6e6277.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/log_1.jpg
// module id = 1890
// module chunks = 0